import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Td, Row } from '@layout/DashboardTable';
import { Icon, Button } from '@atoms';
import { ToggleArrow, Company } from '@molecules';

class OrganizationsTableRow extends PureComponent {
  static propTypes = {
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    company: PropTypes.string,
    country: PropTypes.string.isRequired,
    connectionStatus: PropTypes.string,
    updateOrganizationStarted: PropTypes.func.isRequired,
    updateOrganizationEnd: PropTypes.func.isRequired,
  };

  editOrganization = () => {
    const {
      id,
      updateOrganizationStarted,
      rules = [],
      introMessage,
      ...rest
    } = this.props;

    const checkedRules = rules.map((item) => item.id);
    updateOrganizationStarted({
      id,
      rules: checkedRules,
      introMessageId: introMessage && introMessage.id,
      ...rest,
    });

    this.props.goToEditPage({ id });
  };

  render() {
    const { id, name, company, isActive, country } = this.props;

    return (
      <Fragment>
        <Row background onClick={() => {}}>
          <Td background className="organizations-dashboard-row-id">
            {id}
          </Td>
          <Td background className="organizations-dashboard-row-name">
            {name}
          </Td>
          <Td background className="organizations-dashboard-row-company">
            {company}
          </Td>
          <Td background className="organizations-dashboard-row-country">
            {country}
          </Td>
          <Td background className="organizations-dashboard-row-is-active">
            {isActive ? 'Active' : 'Deactivated'}
          </Td>
          <Td background className="organizations-dashboard-row-action-buttons">
            <Button
              onClick={this.editOrganization}
              invisible
              className="edit-organization"
            >
              <Icon name="pencilGrey" />
            </Button>
          </Td>
        </Row>
      </Fragment>
    );
  }
}

export default OrganizationsTableRow;



// WEBPACK FOOTER //
// ./components/organisms/OrganizationsTable/OrganizationsTableRow.js